function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15 30c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15z",
  fill: "#3B5998"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 12.815h1.464v-.182l.006-1.697c.005-1.272.862-2.139 2.293-2.313.262-.032.528-.045.792-.048.677-.007 1.355-.002 2.032-.002h.202v2.252h-.266c-.435 0-.871-.003-1.307 0-.43.004-.713.26-.713.639v1.344h2.307l-.28 2.18h-2.04v6.4h-3.023v-6.4H12v-2.173z",
  fill: "#fff"
});

var SvgFacebookRedesign = function SvgFacebookRedesign(props) {
  return React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "db0da0ff00ccd09a04d03c68e5def8c2.svg";
export { SvgFacebookRedesign as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/facebook-redesign.svg
// module id = null
// module chunks = 